module.exports = __webpack_public_path__ + "img/artice.413b721e.png";